var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8626 2L4.9542 2V1H10.8626V2ZM12.8397 4.16653H13.8168V3.16653H2V4.16653H2.97707V13.9991C2.97707 14.5514 3.42479 14.9991 3.97707 14.9991H11.8397C12.392 14.9991 12.8397 14.5514 12.8397 13.9991V4.16653ZM11.8397 4.16653H3.97707V13.9991H11.8397V4.16653ZM5.19275 7.27738V10.8882H6.19275V7.27738H5.19275ZM7.40838 10.8882V7.27738H8.40838V10.8882H7.40838ZM9.62403 7.27738V10.8882H10.624V7.27738H9.62403Z",
    fill: "#DF130E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDelete);
export default __webpack_public_path__ + "static/media/icn-delete.b736d808de99a3e6ada91fd4573e2c45.svg";
export { ForwardRef as ReactComponent };